import React, { Component } from "react";
import Modal from "react-modal";
import { MdClose } from "react-icons/md";
import moment from "moment";
import config from "../../../../config";
import axios from "axios";
import ActivityItem from "./ActivityItem";
import CommunicationItem from "./CommunicationItem";
import NoteItem from "./NoteItem";
import DatePicker from "react-datepicker";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

// import utilityFunctions from "../../../../store/utilityFunctions";
import errorFunctions from "../../../../store/errorFunctions";
// import config from "../../../../config";
// const userInfo = utilityFunctions.getCookie("userInfo");
// const userRole = JSON.parse(userInfo).user.role;
Modal.setAppElement("body");
export default class Activities extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showEditNote: false,
      showAddNote: false,
      showAddMedia: false,
      showActivities: true,
      showCommunication: true,
      showNotes: true,
      editedNoteId: "",
      addedNote: "",
      editedNote: "",
      mediaTypeWarning: "",
      showDueDateChangeModal: false,
      history: this.props.details?.ticket_activities.sort(
        (a, b) => new Date(b.created) - new Date(a.created)
      ),
    };
  }

  handleSubmitNote = () => {
    this.setState({
      disableBtnNote: true,
      showAddNote: false,
      showDueDateChangeModal: true,
      dueDateType: "note",
    });
    // this.changeDueDate(true);
  };
  handleSubmitMediaNote = () => {
    this.setState({
      mediaTypeWarning: "",
      showAddMedia: false,
      showDueDateChangeModal: true,
      dueDateType: "media",
    });
  };
  handleInputChange = (e) => {
    const { id, value } = e.target;
    this.setState({
      [id]: value,
    });
  };
  handleFileUpload = (e) => {
    // TODO - verify file upload to make sure it's good
    const file = e.target.files[0];
    const allowedTypes = [
      "image/jpeg",
      "image/png",
      "video/mp4",
      "video/webm",
      "video/quicktime",
      "application/pdf",
    ];

    if (!allowedTypes.includes(file.type)) {
      alert("Only JPG, JPEG, PNG, WEBM, MOV, MP4 and PDF files are allowed.");
      this.setState({
        allowUpload: false,
        mediaTypeWarning:
          "Only JPG, JPEG, PNG, WEBM, MOV, MP4 and PDF files are allowed.",
      });
    } else {
      this.setState({ allowUpload: true, mediaTypeWarning: "" });
    }
    const media = document.getElementById("uploadNoteMedia").files[0];
    this.setState({
      mediaNotes: media,
      dueDateType: "media",
      fileName: file.name,
    });
  };

  handleAddNote = () => {
    let formData = new FormData();
    formData.append("note", this.state.addedNote);
    this.addNote(formData);
  };

  addNote(formData) {
    // const userInfo = localStorage.getItem("lgn") || utilityFunctions.getCookie("userInfo");
    const token = this.props.userInfo.access_token;
    let options = {
      headers: {
        Authorization: "Bearer " + token,
        "Content-Type": "multipart/form-data",
      },
    };

    const url = this.state.editedNoteId
      ? `${config.backendServer}ticket/${this.props.details.id}/note/${this.state.editedNoteId}/`
      : `${config.backendServer}ticket/${this.props.details.id}/note/`;
    axios
      .put(url, formData, options)
      .then((response) => {
        // Log the response to see what fields are available
        console.log("API Response:", response.data);

        this.setState({
          addedNote: "",
          editedNoteId: "",
          editedNote: null,
          showAddNote: false,
          showAddMedia: false,
          disableBtnNote: false,
          isLoading: false,
        });
        this.props.retrieveWarranty();
      })
      .catch((error) => {
        // Handle the error or show an error message
        if (error)
          alert(
            error?.response?.data?.non_field_errors?.[0] ||
              error?.response?.data?.serial_number?.[0] ||
              "Something went wrong.. try later"
          );
        this.setState({ isLoading: false });
      });
  }

  handleAddMedia = () => {
    this.setState({ loading: true, showAddMedia: false });
    // e.preventDefault();
    if (this.state.allowUpload && this.state.mediaNotes) {
      // const mediaNotes = document.getElementById("uploadNoteMedia").files[0];
      let formData = new FormData();
      formData.append("media", this.state.mediaNotes);
      formData.append("note", this.state.mediaNotes.type);
      this.addNote(formData);
    } else {
      // alert("Only JPG, JPEG, PNG, WEBM, MOV and MP4  files are allowed.");
      this.setState({ loading: false, showAddMedia: true });
    }
  };
  changeDueDate(note) {
    this.setState({ disableBtnDueDate: true });
    if (!this.state.showDueDateModal && !note) return;
    if (!this.state.showDueDateChangeModal && note) return;

    const data = {
      reason: "",
      due_date: moment(this.state.due_date).format("YYYY-MM-DD"),
    };

    const url = `${config.backendServer}ticket/${this.props.details.id}/set-due-date/`;
    this.props
      .protectedFetch(url, "PUT", data, errorFunctions.checkResponseThenJson)
      .then(() => {
        if (this.state.dueDateType === "note") this.handleAddNote();
        else if (this.state.dueDateType === "media") this.handleAddMedia();
        this.setState({
          dueDateReason: "",
          showDueDateModal: false,
          showDueDateChangeModal: false,
          disableBtnDueDate: false,
        });
        this.props.retrieveWarranty(this.ticketId);
      })
      .catch((error) => {
        // Handle the error or show an error message
        alert(
          error?.response?.data?.non_field_errors?.[0] ||
            error?.response?.data?.serial_number?.[0] ||
            "Something went wrong.. try later"
        );
        this.setState({ isLoading: false, showDueDateModal: false });
      });
  }
  componentDidMount() {
    Modal.setAppElement("body");
  }

  render() {
    // const details = this.props.details || {};

    let that = this;

    // const history = details.ticket_activities.sort((a, b) => b.id - a.id);
    // if (this.state.showNotes && this.state.showActivities) history = details.ticket_activities;
    // else if (!this.state.showNotes && !this.state.showActivities) history = [];
    // else if (this.state.showNotes) history = details.ticket_activities.filter((d) => d.activity_type === "note");
    // else if (this.state.showActivities) history = details.ticket_activities.filter((d) => d.activity_type === "activity");
    return (
      <div>
        {!this.props.isHeadless && (
          <div className="d-flex flex-row">
            <div className="p-2">
              {" "}
              <button
                type="button"
                className="btn btn-outline-primary btn-sm"
                onClick={() => {
                  this.setState({
                    showAddNote: true,
                    editedNoteId: "",
                    editedNote: null,
                  });
                }}
              >
                Add Note
              </button>
            </div>
            <div className="p-2">
              <button
                type="button"
                className="btn btn-outline-primary mr-3 btn-sm"
                onClick={() => {
                  this.setState({
                    showAddMedia: true,
                    editedNoteId: "",
                    editedNote: null,
                  });
                }}
              >
                Add Picture/Video/PDF
              </button>
            </div>
            <div
              className="p-2"
              style={{ width: "auto", right: "20px", position: "absolute" }}
            >
              <p className="float-right ml-2">
                <input
                  type="checkbox"
                  id="change"
                  data-testid="change"
                  name="vehicle1"
                  value={this.state.showCommunication}
                  checked={this.state.showCommunication}
                  onChange={() =>
                    this.setState({
                      showCommunication: !this.state.showCommunication,
                    })
                  }
                />
                <label htmlFor="change" className="ml-2">
                  {" "}
                  Communication
                </label>
              </p>
              <p className="float-right ml-2">
                <input
                  type="checkbox"
                  id="note"
                  data-testid="note"
                  name="notes"
                  value={this.state.showNotes}
                  checked={this.state.showNotes}
                  onChange={() =>
                    this.setState({ showNotes: !this.state.showNotes })
                  }
                />
                <label htmlFor="vehicle1" className="ml-2">
                  {" "}
                  Notes
                </label>
              </p>
              <p className="float-right ml-2">
                <input
                  type="checkbox"
                  id="change"
                  data-testid="change"
                  name="vehicle1"
                  value={this.state.showActivities}
                  checked={this.state.showActivities}
                  onChange={() =>
                    this.setState({
                      showActivities: !this.state.showActivities,
                    })
                  }
                />
                <label htmlFor="change" className="ml-2">
                  {" "}
                  Changes
                </label>
              </p>
            </div>
          </div>
        )}
        <div className={"activity-wrapper"}>
          {/* <h4 className={"single-warranty-header"}>History and comments</h4> */}
          <ul style={{ padding: "0px" }}>
            {this.state.history?.map(function (item, i) {
              // "activity_type": "note",
              const isNote = item.activity_type === "note";
              const isActivity = item.activity_type === "activity";
              const isCommunication = item.activity_type === "communication";
              const isMyNote =
                item.subject?.includes(that.props.userInfo?.user.name) &&
                !that.props.userInfo?.user.role?.includes("Contractor");
              const isPicture =
                item.media &&
                (item.media.toLowerCase().includes(".jpg") ||
                  item.media.toLowerCase().includes(".png") ||
                  item.media.toLowerCase().includes(".jpeg"));
              const isVideo =
                item.media &&
                (item.media.toLowerCase().includes(".mp4") ||
                  item.media.toLowerCase().includes(".mov") ||
                  item.media.toLowerCase().includes(".webm"));
              if ((isNote && that.state.showNotes) || item.activity_type === null)
                return (
                  <NoteItem
                    userInfo={that.props?.userInfo}
                    activity={item}
                    isMyNote={isMyNote}
                    isPicture={isPicture}
                    isVideo={isVideo}
                    key={i}
                    handleEditNote={(formData) => that.addNote(formData)}
                    ticketId={that.props.details.id}
                    retrieveWarranty={() => that.props.retrieveWarranty()}
                    // handleShowAddNote={() => that.setState({ showAddNote: true, editedNote: item.detail, editedNoteId: item.id })}
                    // handleShowAddMedia={() =>
                    //   that.setState({ showAddMedia: true, mediaNotes: item.media, editedNoteId: item.id, editedNote: item.detail })
                    // }
                  />
                );
              else if (isActivity && that.state.showActivities)
                return <ActivityItem activity={item} key={i} />;
              else if (isCommunication && that.state.showCommunication)
                return (
                  <CommunicationItem
                    communication={item}
                    key={i}
                    retrieveWarranty={() => that.props.retrieveWarranty()}
                  />
                );
            })}
          </ul>
        </div>
        <Modal
          isOpen={this.state.showAddNote}
          //onRequestClose={()=>this.setState({showDeclineModal: false})}
          contentLabel={"Add Note"}
          className={"input-modal w-25 h-50 "}
        >
          <div className="card  h-100">
            <button
              onClick={() => this.setState({ showAddNote: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className={"card-header"}>{`${
              this.state.editedNote ? "Edit" : "Add"
            } Note`}</div>
            <div className="card-body overflow-auto">
              <ReactQuill
                height={"100%"}
                value={this.state.addedNote || this.state.editedNote || ""}
                onChange={(val) => this.setState({ addedNote: val })}
                id={"editedNote"}
              />
            </div>
            <div className="card-footer">
              <button
                disabled={this.state.disableBtnNote}
                type="button"
                className={"btn btn-outline-primary mr-3"}
                onClick={this.handleSubmitNote}
              >
                Save
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() =>
                  this.setState({ showAddNote: false, addedNote: "" })
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showAddMedia}
          contentLabel={"Add Note"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showAddMedia: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">{`${
              this.state.editedNote ? "Edit" : "Add"
            } Picture / Video / PDF`}</div>
            <div className="card-body">
              <label
                htmlFor="uploadNoteMedia"
                style={{
                  display: "flex",
                  flexDirection: "column",
                  alignItems: "center",
                  justifyContent: "center",
                  border: `2px dashed ${this.state.mediaTypeWarning ? "#dc3545" : "#b0b8c1"}`,
                  borderRadius: "10px",
                  padding: "28px 16px",
                  cursor: "pointer",
                  background: "#f8f9fa",
                  textAlign: "center",
                  transition: "border-color 0.2s",
                }}
              >
                <svg xmlns="http://www.w3.org/2000/svg" width="40" height="40" fill="#6c757d" viewBox="0 0 16 16" style={{ marginBottom: "10px" }}>
                  <path d="M.5 9.9a.5.5 0 0 1 .5.5v2.5a1 1 0 0 0 1 1h12a1 1 0 0 0 1-1v-2.5a.5.5 0 0 1 1 0v2.5a2 2 0 0 1-2 2H2a2 2 0 0 1-2-2v-2.5a.5.5 0 0 1 .5-.5" />
                  <path d="M7.646 1.146a.5.5 0 0 1 .708 0l3 3a.5.5 0 0 1-.708.708L8.5 2.707V11.5a.5.5 0 0 1-1 0V2.707L5.354 4.854a.5.5 0 1 1-.708-.708z" />
                </svg>
                <div style={{ fontWeight: "600", color: "#343a40", marginBottom: "4px", wordBreak: "break-all" }}>
                  {this.state.fileName || (this.state.editedNote ? this.state.editedNote : "Click to choose a file")}
                </div>
                <small style={{ color: "#6c757d" }}>JPG, PNG, MP4, WEBM, MOV, PDF</small>
              </label>
              <input
                accept="image/jpeg, image/png, video/mp4, video/webm, video/quicktime, application/pdf"
                type={"file"}
                id={"uploadNoteMedia"}
                data-testid="uploadNoteMedia"
                style={{ display: "none" }}
                required={true}
                onChange={this.handleFileUpload}
              />
              {this.state.mediaTypeWarning && (
                <div className="text-danger mt-2">
                  <small>{this.state.mediaTypeWarning}</small>
                </div>
              )}
            </div>
            <div className="card-footer">
              <button
                data-testid={"saveNoteMedia"}
                disabled={this.state.disableBtnNote}
                type="submit"
                className={"btn btn-outline-primary mr-3"}
                onClick={() =>
                  this.state.allowUpload && this.handleSubmitMediaNote()
                }
              >
                Save
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() =>
                  this.setState({ showAddMedia: false, addedNote: "" })
                }
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
        <Modal
          isOpen={this.state.showDueDateChangeModal}
          //onRequestClose={()=>this.setState({showDeclineModal: false})}
          contentLabel={"Add Note"}
          className={"input-modal"}
        >
          <div className="card">
            <button
              onClick={() => this.setState({ showDueDateChangeModal: false })}
              className={"confirm-modal-close"}
            >
              <MdClose />
            </button>
            <div className="card-header">Change Due date </div>
            <div className="card-body">
              <div className={"form-field"}>
                <span style={{ marginRight: "15px" }}>Due date : </span>
                <DatePicker
                  id="due-field-datepicker"
                  selected={this.state.due_date}
                  dateFormat="dd/MM/yyyy"
                  onChange={(val) => {
                    this.setState({
                      due_date: val,
                    });
                    // this.changeDueDate()
                  }}
                  style={{ width: "50vw !important" }}
                />
              </div>
            </div>
            <div className="card-footer">
              <button
                disabled={this.state.disableBtnDueDate}
                type="submit"
                className={"btn btn-outline-primary mr-3"}
                onClick={() => this.changeDueDate(true)}
              >
                Save
              </button>
              <button
                type={"button"}
                className={"btn btn-outline-secondary"}
                onClick={() => this.setState({ showDueDateChangeModal: false })}
              >
                Cancel
              </button>
            </div>
          </div>
        </Modal>
      </div>
    );
  }
}
